import { createRouter as create, createWebHistory, type Router } from 'vue-router';

import { WILDCARD_PATH } from '@/core/lib/RouterUtils';
import { RouteName } from '@/core/router/RouteName';
import { addNavigationGuards } from '@/core/router/RouterNavigationGuards';
import { scrollBehavior } from '@/core/router/RouterScrollBehavior';
import { getAuthentication, logout } from '@/plugins/authentication/lib/Authentication';

export interface CreateRouterConfig {
  marque: string;
}

export function createRouter(): Router {
  const router = create({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        name: RouteName.ERROR,
        path: '/erreur',
        component: () => import('@/views/ErrorPageDefault.vue'),
      },
      {
        name: RouteName.ERROR_ACCESS_DENIED,
        path: '/403',
        component: () => import('@/views/ErrorPageAccessDenied.vue'),
      },
      {
        name: RouteName.ERROR_NOT_FOUND,
        path: '/introuvable',
        component: () => import('@/views/ErrorPageNotFound.vue'),
      },
      {
        name: RouteName.LOGOUT,
        path: '/logout',
        component: () => import('@/views/LoadingPage.vue'),
        beforeEnter: async () => {
          const authState = (await getAuthentication()).getState();

          logout(authState);
        },
      },
      {
        path: WILDCARD_PATH,
        component: () => import('@/views/ErrorPageNotFound.vue'),
      },
    ],
    scrollBehavior,
  });

  addNavigationGuards(router);

  return router;
}
